

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M4.25 6C4.25 2.83 6.83.25 10 .25S15.75 2.83 15.75 6s-2.58 5.75-5.75 5.75S4.25 9.17 4.25 6Zm1.5 0A4.26 4.26 0 0 0 10 10.25 4.26 4.26 0 0 0 14.25 6 4.26 4.26 0 0 0 10 1.75 4.26 4.26 0 0 0 5.75 6Zm12.09 15c0-3.45-3.52-6.25-7.84-6.25S2.16 17.55 2.16 21c0 .41-.34.75-.75.75S.66 21.41.66 21c0-4.27 4.19-7.75 9.34-7.75 5.15 0 9.34 3.48 9.34 7.75 0 .41-.34.75-.75.75s-.75-.34-.75-.75Z"}, []), "\n"]);
};

        